import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { Cloudy, CloudLightning, Leaf, LeafyGreen, Snowflake, Sparkle, Sparkles, Wand2 } from 'lucide-react';
import { useEffect, useState } from 'react';

function EffectModal({ visible, onCancel, onSelect, onClear, mode = 'light', cinematicModeActive = false }) {
  const isDark = mode === 'dark';
  const [isPhone, setIsPhone] = useState(false);

  useEffect(() => {
    const mediaQueryWidth = window.matchMedia('(max-width: 620px)');
    const handleMediaChange = () => {
      setIsPhone(mediaQueryWidth.matches);
    };
    handleMediaChange();
    mediaQueryWidth.addListener(handleMediaChange);
    return () => {
      mediaQueryWidth.removeListener(handleMediaChange);
    };
  }, []);

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onCancel}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: isDark ? '2px solid var(--onyx)' : '2px solid #e4E7C5',
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: isPhone ? 'calc(100% - 34px)' : 379,
        height: isPhone ? 'calc(100% - 114px)' : 400,
        marginTop: isPhone ? '80px' : '',
      }}
    >
      <div
        className={`trialment_login_form ${isDark ? 'df_modal_form_dark' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div style={{ flex: 1, overflowY: isPhone ? 'auto' : 'visible' }}>
          <div
            className='trialment_login_form_row'
            style={{ fontWeight: 700, fontSize: 16, marginBottom: 6, textAlign: 'center' }}
          >
            Select an Effect for this Scene
          </div>
          <div
            className='trialment_login_form_row'
            style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}
          >
            <Button icon={LeafyGreen} label='Autumn Leaves' type='cinnabar' onPress={() => onSelect('leavesAutumn')} />
            <Button icon={Leaf} label='Summer Leaves' type='cinnabar' onPress={() => onSelect('leavesSummer')} />
            <Button icon={Cloudy} label='Smog' type='cinnabar' onPress={() => onSelect('smog')} />
            <Button icon={Snowflake} label='Snow' type='cinnabar' onPress={() => onSelect('blizzard')} />
            <Button icon={CloudLightning} label='Storm' type='cinnabar' onPress={() => onSelect('storm')} />
            <Button icon={Sparkle} label='Fireflies' type='cinnabar' onPress={() => onSelect('fireflies')} />
            <Button icon={Sparkles} label='Fog + Fireflies' type='cinnabar' onPress={() => onSelect('enchantedFogFireflies')} />
            <Button icon={Wand2} label='Enchanted Fog' type='cinnabar' onPress={() => onSelect('enchantedFog')} />
            <Button
              label='Cinematic Mode'
              type={cinematicModeActive ? 'blue' : 'cinnabar'}
              description={cinematicModeActive ? 'Remove black bars from the Display' : 'Add Black bars to the Display'}
              descriptionUp
              onPress={() => onSelect(cinematicModeActive ? null : 'cinematicMode')}
            />

          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        >
          <Button label='Clear Effect' type={mode === 'dark' ? 'onyx' : 'black-white'} onPress={onClear} />
          <Button label='Close' type={mode === 'dark' ? 'onyx' : 'black-white'} onPress={onCancel} />
        </div>
      </div>
    </Rodal>
  );
}

export default EffectModal;
